// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChatMessageController from "./chat_message_controller"
application.register("chat-message", ChatMessageController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import PdfTranslatorController from "./pdf_translator_controller"
application.register("pdf-translator", PdfTranslatorController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import SyncScrollController from "./sync_scroll_controller"
application.register("sync-scroll", SyncScrollController)

import TranslationController from "./translation_controller"
application.register("translation", TranslationController)

import TranslationScrollController from "./translation_scroll_controller"
application.register("translation-scroll", TranslationScrollController)

import TranslationsListController from "./translations_list_controller"
application.register("translations-list", TranslationsListController)
